"use client";

import { useEffect } from "react";
import Link from "next/link";
import { CONTACTS } from "@/lib/contacts";

/**
 * Error boundary para el grupo de rutas (public).
 * Aísla los errores de landings/blog de otros grupos — sin él
 * un error en cualquier página pública tumba toda la app (se renderiza el root error.tsx
 * sin layout/nav local).
 */
export default function PublicError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[public/error]", error);
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-stone-50 px-4 py-20">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto mb-6">
          <span className="text-3xl">😔</span>
        </div>
        <h1 className="text-2xl font-bold text-stone-900 mb-3">
          La página no está disponible temporalmente
        </h1>
        <p className="text-stone-500 text-sm leading-relaxed mb-8">
          Intenta recargar la página o vuelve al inicio. Si el error se repite, escríbenos a {CONTACTS.general}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={reset}
            className="inline-flex items-center justify-center gap-2 bg-violet-600 hover:bg-violet-700 text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition-colors"
          >
            Intentar de nuevo
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 bg-white border border-stone-200 hover:bg-stone-50 text-stone-700 text-sm font-semibold px-5 py-2.5 rounded-xl transition-colors"
          >
            Al inicio
          </Link>
        </div>
        {error.digest && (
          <p className="text-xs text-stone-500 mt-6">Código de error: {error.digest}</p>
        )}
      </div>
    </div>
  );
}
